import { cn } from '~/utils/classnames'

const Skeleton = ({
  className,
  ...props
}: React.ComponentPropsWithRef<'div'>) => {
  return (
    <div
      className={cn('w-full animate-pulse bg-current/10', className)}
      {...props}
    />
  )
}

export { Skeleton }
